import FormSelectField from "./FormSelectField";
import React from "react";
import {SelectProps} from "@mui/material/Select/Select";
import {FormikProps} from "formik";
import {TFunction} from "i18next";
import {COUNTRY_CODE_NAMES} from "../../enums";
import MenuItem from "@mui/material/MenuItem";
import {get} from "lodash";
import {getTranslation, TranslationContext} from "../../utils/getTranslationKey";
import {Grid} from "@mui/material";
import {GridTypeMap} from "@mui/material/Grid/Grid";

export interface CountrySelectProps extends Omit<SelectProps, "label"> {
    fieldName: string;
    label: string;
    form: FormikProps<any>;
    isGridItem?: boolean;
    gridProps?: GridTypeMap["props"];
    t: TFunction;
}

const CountrySelect = ({
    fieldName,
    label,
    form,
    t,
    isGridItem = false,
    gridProps = {xs: 6},
    ...rest
}: CountrySelectProps) => {
    const getSelect = () => (
        <>
            <FormSelectField
                fieldName={fieldName}
                form={form}
                label={label}
                {...rest}
                value={get(form?.values, fieldName)}
            >
                {Object.keys(COUNTRY_CODE_NAMES).map((countryEntry, index) => {
                    return (
                        <MenuItem value={countryEntry} key={`${fieldName}_${index}`}>
                            {getTranslation({context: TranslationContext.COUNTRY, value: countryEntry, t})}
                        </MenuItem>
                    );
                })}
            </FormSelectField>
        </>
    );
    return isGridItem ? (
        <Grid item {...gridProps}>
            {getSelect()}
        </Grid>
    ) : (
        getSelect()
    );
};
export default CountrySelect;
